import MButton from '@assets/mui/@material-extend/MButton';
import FavoriteIcon from '@components/icons/FavoriteIcon';
import { useBitrix } from '@context/useBitrixUser/useBitrix';
import { isProductEquals } from '@pages/Basket/useBasket';
import { OrderProductType } from '@services/requests/orderService/interface';
import { OrderProduct } from '@services/requests/orderService/orderProductsLoader/interface';
import clsx from 'clsx';
import React, { MouseEventHandler, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FavoritesButtonProps {
  isMobile: boolean;
  productData: {
    product_type: OrderProductType;
    data: string;
    token: string;
    amount: number;
    price: number;
  };
}
export const FavoritesButton = ({ isMobile, productData }: FavoritesButtonProps) => {
  const {
    actions: { addFavoritesProduct, deleteFavoritesProduct },
    useBitrixUser,
  } = useBitrix();
  const [{ favorites }] = useBitrixUser().useState(['favorites']);
  const { t } = useTranslation(['RoutesListComponent', 'Common', 'OrderList', 'Actions']);
  const [isActionsDisabled, setIsActionsDisabled] = useState<boolean>(false);
  const [isProductInFavorites, setIsProductInFavorites] = useState<boolean>(false);

  useEffect(() => {
    setIsProductInFavorites(
      !!favorites.find((product) => {
        return isProductEquals(JSON.parse(product.data) as OrderProduct, productData);
      })
    );
  }, [productData, favorites]);

  /**
   * Обработчик добавления в избранное
   */
  const addToFavoritesHandler: MouseEventHandler = useCallback(
    async (event) => {
      event.preventDefault();

      if (!productData) {
        return;
      }

      setIsActionsDisabled(true);
      await addFavoritesProduct({ type: 'route', data: JSON.stringify(productData) });
      setIsActionsDisabled(false);
    },
    [productData]
  );

  /**
   * Обработчик удаления из избранного
   */
  const removeFromFavoritesHandler: MouseEventHandler = useCallback(
    async (event) => {
      event.preventDefault();

      if (!productData) {
        return;
      }

      const foundFavoriteProduct = favorites.find((product) =>
        isProductEquals(JSON.parse(product.data) as OrderProduct, productData)
      );

      if (!foundFavoriteProduct) {
        return;
      }

      setIsActionsDisabled(true);
      await deleteFavoritesProduct({ id: foundFavoriteProduct.id });
      setIsActionsDisabled(false);
    },
    [favorites, productData]
  );
  return (
    <MButton
      fullWidth={true}
      variant={isMobile ? 'outlined' : 'text'}
      size={'small'}
      color={'inherit'}
      className={clsx('offer-actions fav-button', { active: isProductInFavorites })}
      disabled={isActionsDisabled}
      onClick={!isProductInFavorites ? addToFavoritesHandler : removeFromFavoritesHandler}
      startIcon={
        !isMobile && (
          <FavoriteIcon
            color={'inherit'}
            fill={isProductInFavorites ? '#3460B4' : 'none'}
            stroke={isProductInFavorites ? '#3460B4' : 'currentColor'}
            sx={{ fontSize: '20px!important' }}
          />
        )
      }
    >
      {isMobile ? (
        <FavoriteIcon
          color={'inherit'}
          sx={{ fontSize: '26px' }}
          fill={isProductInFavorites ? '#3460B4' : 'none'}
          stroke={isProductInFavorites ? '#3460B4' : 'currentColor'}
        />
      ) : (
        <>
          {!isProductInFavorites && t('Actions:ToFavorites')}
          {isProductInFavorites && t('DeliveryItem:Favorites')}
        </>
      )}
    </MButton>
  );
};
